// extracted by mini-css-extract-plugin
export default {"videoWrapper":"HoverVideo_videoWrapper","visible":"HoverVideo_visible"};